// Spanish — generic (es). Seeded from the native app's vetted es catalog; uses
// the Spain register (matches native es.js, which mirrors es-ES).
export default {
  // --- Shell / nav ---
  app_name: 'Mareas cercanas',
  search_stations: 'Buscar estaciones',
  search_stations_hint: 'Buscar estaciones (⌘K)',
  settings: 'Ajustes',
  app_store: 'Descárgala en el App Store',
  google_play: 'Disponible en Google Play',
  app_promo_title: 'Descarga la app gratis. Es más rápida 🙂',
  app_promo_body: 'Las mismas predicciones de mareas y corrientes, en tu teléfono.',
  privacy: 'Privacidad',
  terms: 'Términos',
  data_sources: 'Fuentes de datos',
  support: 'Soporte',

  guides: 'Guías',
  // --- Home ---
  home_title: 'Encuentra mareas y corrientes cercanas',
  by_country: 'Por país',
  favorite_tides: 'Mareas favoritas',
  recent_tides: 'Mareas recientes',
  nearby_tides: 'Mareas cercanas',
  favorite_currents: 'Corrientes favoritas',
  recent_currents: 'Corrientes recientes',
  nearby_currents: 'Corrientes cercanas',
  favorite_charts: 'Cartas náuticas favoritas',
  recent_charts: 'Cartas náuticas recientes',
  nearby_charts: 'Cartas náuticas cercanas',
  finding_stations: 'Buscando estaciones cerca de ti…',
  distance_away: 'A {{distance}}',

  // --- Search overlay ---
  search_placeholder: 'Buscar estaciones…',
  tide_stations: 'Estaciones de mareas',
  current_stations: 'Estaciones de corrientes',
  recents: 'Recientes',
  search_unavailable: 'La búsqueda no está disponible en este momento.',
  no_stations_found: 'No se han encontrado estaciones.',
  search_prompt: 'Busca estaciones de mareas y corrientes por nombre.',

  // --- Settings ---
  appearance: 'Apariencia',
  appearance_system: 'Sistema',
  appearance_light: 'Claro',
  appearance_dark: 'Oscuro',
  tide_height: 'Altura de marea',
  unit_feet: 'Pies',
  unit_meters: 'Metros',
  distance: 'Distancia',
  unit_miles: 'Millas',
  unit_kilometers: 'Kilómetros',
  recent_stations: 'Estaciones recientes',
  clear_recents: 'Borrar recientes',
  currents: 'Corrientes',
  nautical_charts: 'Cartas náuticas',
  browse_by_country: 'Explorar por país',
  countries_auto: 'Automático',
  countries_always: 'Siempre',
  countries_never: 'Nunca',
  show: 'Mostrar',
  hide: 'Ocultar',

  // --- Station pages (tide + current) ---
  tide_title: 'Mareas de {{name}}',
  current_title: 'Corrientes de {{name}}',
  last_tide: 'Última marea',
  next_tide: 'Próxima marea',
  coefficient: 'Coef',
  last_current: 'Última corriente',
  next_current: 'Próxima corriente',
  following_current: 'Corriente siguiente',
  high: 'Alta',
  low: 'Baja',
  tides: 'Mareas',
  sun: 'Sol',
  moon: 'Luna',
  sunrise_now: 'Amanecer',
  sunset_now: 'Puesta de sol',
  moonrise_now: 'Salida de la luna',
  moonset_now: 'Puesta de la luna',
  sunrise_week: 'Salida',
  sunset_week: 'Puesta',
  moonrise_week: 'Salida',
  moonset_week: 'Puesta',
  add_to_favorites: 'Añadir a favoritos',
  remove_from_favorites: 'Quitar de favoritos',

  // --- Week table dates ---
  today: 'Hoy',
  tomorrow: 'Mañana',

  // --- Moon phases ---
  phase_new_moon: 'Luna nueva',
  phase_waxing_crescent: 'Luna creciente',
  phase_first_quarter: 'Cuarto creciente',
  phase_waxing_gibbous: 'Luna gibosa creciente',
  phase_full_moon: 'Luna llena',
  phase_waning_gibbous: 'Luna gibosa menguante',
  phase_last_quarter: 'Cuarto menguante',
  phase_waning_crescent: 'Luna menguante',

  // --- Tide / current status vocabulary ---
  rising: 'Subiendo',
  falling: 'Bajando',
  high_tide: 'Pleamar',
  low_tide: 'Bajamar',
  ebb: 'Reflujo',
  flood: 'Flujo',
  slack: 'Estoa',

  // --- Relative time ---
  just_now: 'Ahora mismo',
  somethings_wrong: 'Se ha producido un error',
  hour_ago: 'Hace {{hour}} hora',
  hours_ago: 'Hace {{hour}} horas',
  minute_ago: 'Hace {{minute}} minuto',
  minutes_ago: 'Hace {{minute}} minutos',
  hour_minute_ago: 'Hace {{hour}} hora y {{minute}} minuto',
  hour_minutes_ago: 'Hace {{hour}} hora y {{minute}} minutos',
  hours_minute_ago: 'Hace {{hour}} horas y {{minute}} minuto',
  hours_minutes_ago: 'Hace {{hour}} horas y {{minute}} minutos',
  hour_from_now: 'Dentro de {{hour}} hora',
  hours_from_now: 'Dentro de {{hour}} horas',
  minute_from_now: 'Dentro de {{minute}} minuto',
  minutes_from_now: 'Dentro de {{minute}} minutos',
  hour_minute_from_now: 'Dentro de {{hour}} hora y {{minute}} minuto',
  hour_minutes_from_now: 'Dentro de {{hour}} hora y {{minute}} minutos',
  hours_minute_from_now: 'Dentro de {{hour}} horas y {{minute}} minuto',
  hours_minutes_from_now: 'Dentro de {{hour}} horas y {{minute}} minutos',

  // --- Insights ---
  insights_7_day_overview: 'Información de 7 días',
  no_insights_available: 'No hay perspectivas disponibles para esta estación.',
  insights_current_extremes: 'Extremos de corriente',
  insights_fastest_flood: 'Flujo más rápido',
  insights_fastest_ebb: 'Reflujo más rápido',
  insights_strongest_daily_currents: 'Corrientes diarias máximas',
  insights_fastest_current: 'Más rápida',
  insights_slowest_current: 'Más lenta',
  insights_tidal_extremes: 'Extremos de marea',
  insights_highest_tide: 'Marea más alta',
  insights_lowest_tide: 'Marea más baja',
  insights_strongest_daily_movements: 'Mayores rangos de marea',
  insights_largest_tide: 'Mayor',
  insights_smallest_tide: 'Menor',
  insights_value_at_time: '{{value}} a las {{time}}',
  insights_tidal_range_label: 'rango de mareas',
  insights_max_current_label: 'corriente máxima',

  // --- Insight bands ---
  band_smaller_than_usual: 'Menor de lo habitual',
  band_typical: 'Típico',
  band_larger_than_usual: 'Mayor de lo habitual',
  band_unusually_large: 'Inusualmente grande',
  band_lower_than_usual: 'Más baja de lo habitual',
  band_unusually_low: 'Inusualmente baja',
  band_slower_than_usual: 'Más lenta de lo habitual',
  band_faster_than_usual: 'Más rápida de lo habitual',
  band_unusually_fast: 'Inusualmente rápida',
  band_smaller_than_usual_height: 'Más baja de lo habitual',
  band_larger_than_usual_height: 'Más alta de lo habitual',
  band_unusually_large_height: 'Inusualmente alta',

  // --- Map attribution ---
  attribution: 'Atribución',
  attribution_osm: 'Datos del mapa © Colaboradores de OpenStreetMap',
  attribution_tiles: 'Mosaicos de mapa de OpenFreeMap',
  attribution_style: 'Estilo del mapa © OpenMapTiles',
  ok: 'OK',

  // --- Explore map ---
  current_speed: 'Velocidad de corriente',
  depth: 'Profundidad',
  speed: 'Velocidad',
  depth_datum: 'Profundidades desde',
  depth_drying: 'Seca',
  depth_loading: 'Cargando datos de profundidad…',
  depth_datum_tag: 'Profundidades en {{unit}} bajo {{datum}}',
  depth_not_for_navigation: 'No apto para la navegación.',
  depth_unavailable: 'Los datos de profundidad no están disponibles en este momento.',
  depth_unit_m: 'm',
  depth_unit_ft: 'ft',
  go_mode_start: 'IR',
  go_mode_start_label: 'Iniciar',
  go_mode_exit: 'Salir',
  go_mode_location_denied: 'El modo Go necesita tu ubicación. Actívalo con el icono del candado.',
  go_mode_location_denied_ok: 'OK',
  radar: 'Radar',
  radar_precipitation: 'Precipitación',
  radar_light: 'ligera',
  radar_moderate: 'moderada',
  radar_heavy: 'fuerte',
  radar_storm: 'torrencial',
  radar_forecast: 'pronóstico',
  radar_none_for_time: 'sin radar para esta hora',
  now: 'Ahora',
  explore_prompt_denied:
    'La ubicación está desactivada para este sitio: actívala con el icono del candado en la barra de direcciones.',
  open_full_map: 'Abrir el mapa completo',
  close_full_map: 'Cerrar el mapa completo',
  explore_full_map: 'Explora el mapa completo',
  center_on_location: 'Centrar en mi ubicación',
  show_my_location: 'Mostrar mi ubicación',
  map_knots_label: '{{speed}} kt',

  // --- Location pages ---
  states: 'estados',
  no_stations_found_location: 'No se han encontrado estaciones.',
  tides_and_currents_by_country: 'Mareas y corrientes por país',

  // --- SEO titles / descriptions ---
  settings_seo_description: 'Elige tus unidades para las alturas de marea y las distancias.',
  tide_seo_description:
    'Predicciones de mareas, horarios de pleamar y bajamar para {{name}}{{location}}.',
  current_seo_description:
    'Predicciones de corrientes de marea, horarios de flujo y reflujo para {{name}}{{location}}.',
  location_title: 'Mareas y corrientes de {{name}}',
  country_seo_description:
    'Horarios de mareas y predicciones de corrientes de marea para {{name}}. Explora {{stateTerm}} y estaciones de mareas costeras de {{name}}.',
  state_seo_description:
    'Predicciones de mareas y corrientes para {{name}}, {{country}}. Horarios de pleamar y bajamar para estaciones costeras en {{name}}.',
  city_seo_description:
    'Horarios de mareas y predicciones de corrientes de marea para {{place}}. Mareas altas y bajas y corrientes cerca de {{name}}.',
  // --- Chart pages (chart titles, numbers and purposes stay in the
  // issuing authority's language: they name a specific printed sheet) ---
  charts_for_station: 'Cartas náuticas de {{name}}',
  chart_intro:
    'Carta náutica gratuita de {{title}}: profundidades cartografiadas, boyas, balizas, rocas, pecios, puertos deportivos, fondeaderos y estaciones de mareas.',
  chart_page_name: 'Carta náutica de {{title}}',
  chart_seo_description:
    'Carta náutica gratuita de {{title}}: profundidades cartografiadas, boyas, balizas, rocas, pecios, puertos deportivos, fondeaderos y estaciones de mareas.',

  countries_seo_title: 'Estaciones de mareas y corrientes por país',
  countries_seo_description:
    'Explora estaciones de mareas y corrientes por país. Horarios de pleamar y bajamar y pronósticos de corrientes de marea para ubicaciones costeras de todo el mundo.',
  home_seo_description:
    'Consulta los horarios de mareas y las predicciones de corrientes de marea de las estaciones costeras cercanas. Ve la pleamar y la bajamar de tu ubicación o explora estaciones por país.',
  explore_play: 'Reproducir',
  explore_pause: 'Pausar',
  explore_playback_speed: 'Velocidad de reproducción',
  explore_time: 'Hora',
  skip_to_content: 'Saltar al contenido principal',
  // --- Weather (station pages) ---
  weather: 'Meteorología marina',
  wind: 'Viento',
  gusts: 'Rachas',
  seas: 'Oleaje',
  time: 'Hora',
  air_temp: 'Aire',
  water_temp: 'Agua',
  water_temperature: 'Temperatura del agua',
  humidity: 'Humedad',
  pressure: 'Presión',
  precip_chance: 'Precipitación',
  chances: 'Probabilidad',
  precip_rate: 'Intensidad de precipitación',
  visibility: 'Visibilidad',
  condition_thunderstorms: 'Tormentas',
  condition_freezing_rain: 'Lluvia helada',
  condition_sleet: 'Aguanieve',
  condition_snow: 'Nieve',
  condition_fog: 'Niebla',
  condition_rain: 'Lluvia',
  condition_cloudy: 'Nublado',
  condition_partly_cloudy: 'Parcialmente nublado',
  condition_clear: 'Despejado',
  weather_thunder: 'Tormenta',
  note_seas_computed_from_wind: 'La altura del oleaje se estima a partir del viento y la costa.',
  note_seas_from_nearby_open_water: 'El oleaje procede de aguas abiertas cercanas.',
  note_seas_open_water_nearby:
    'Las olas en las aguas abiertas cercanas rondan {{height}}. Aquí el agua puede estar más tranquila.',
  note_seas_open_water_distant:
    'Las olas en aguas abiertas a {{distance}} rondan {{height}}. Aquí el agua puede estar más tranquila.',
  note_seas_open_water_distant_dir:
    'Las olas en aguas abiertas a {{distance}} al {{direction}} de aquí rondan {{height}}. Aquí el agua puede estar más tranquila.',
  note_seas_unavailable: 'No hay datos fiables de oleaje para este punto.',
  note_sheltered_water_sees_less:
    'En aguas resguardadas el oleaje suele ser menor que estos valores de mar abierto.',
  note_no_warning_feed_coverage: 'Ningún servicio oficial de avisos marítimos cubre este punto.',
  note_nearest_point_across_land: 'El punto de pronóstico más cercano está al otro lado de tierra.',
  warnings_none_active: 'No hay avisos marítimos en vigor',
  warnings_unavailable: 'Los avisos marítimos no están disponibles para esta ubicación',
  warning_show_text: 'Mostrar texto oficial',
  warning_hide_text: 'Ocultar texto oficial',
  weather_updated: 'Actualizado {{time}}',
  current_conditions: 'Condiciones actuales',
  daily_forecast: 'Pronóstico diario',
  expand_for_hourly: 'Ampliar para ver por horas',
  hourly: 'Por horas',
  hourly_forecast: 'Pronóstico por hora',
  wind_speed: 'Velocidad del viento',
  wind_gusts: 'Viento y rachas',
  pressure_humidity: 'Presión y humedad',
  max_seas: 'Oleaje máximo',
  visibility_excellent: 'Excelente',
  visibility_good: 'Buena',
  visibility_moderate: 'Moderada',
  visibility_poor: 'Mala',
  forecaster_text_link: 'Texto del pronóstico de {{issuer}}',
  temperature: 'Temperatura',
  unit_fahrenheit: 'Fahrenheit',
  unit_celsius: 'Celsius',
  // --- Conditions summary (station pages) ---
  // Sea state: WMO Sea State Code. Wind: Beaufort. Both are published
  // scales with standard terminology in each language, not our own wording.
  // Warning-window and low–high range punctuation. CJK marks a range (and
  // an open end) with ～, not an en dash or a trailing plus.
  warning_window_range: '{{start}} – {{end}}',
  warning_window_open: '{{start}}+',
  range_separator_short: '-',
  // Wave-period fragments. The connector is the locale's own word for the
  // "at" in "0.5 m S @ 3s" (CJK says "period" instead); the value carries
  // the locale's seconds notation (秒/초 — bare Latin "s" reads as an
  // untranslated fragment in CJK weather products).
  seas_period_at: 'a',
  wave_period_short: '{{period}}s',
  // 16-point compass, per this locale’s meteorological convention — the
  // letters differ across languages (Z/O/Ø/V…) and CJK writes the words out.
  compass_N: 'N',
  compass_NNE: 'NNE',
  compass_NE: 'NE',
  compass_ENE: 'ENE',
  compass_E: 'E',
  compass_ESE: 'ESE',
  compass_SE: 'SE',
  compass_SSE: 'SSE',
  compass_S: 'S',
  compass_SSW: 'SSO',
  compass_SW: 'SO',
  compass_WSW: 'OSO',
  compass_W: 'O',
  compass_WNW: 'ONO',
  compass_NW: 'NO',
  compass_NNW: 'NNO',
  // Known warning types, one badge label each. Bureau-home locales use the
  // bureau’s official terminology. Unknown types fall back to the humanized
  // English code in every locale (see warningTypeLabel).
  warning_type_small_craft_advisory: 'Aviso para embarcaciones menores',
  warning_type_gale_warning: 'Aviso de temporal',
  warning_type_gale_watch: 'Vigilancia de temporal',
  warning_type_storm_warning: 'Aviso de temporal fuerte',
  warning_type_storm_watch: 'Vigilancia de temporal fuerte',
  warning_type_hurricane_force_wind_warning: 'Aviso de vientos con fuerza de huracán',
  warning_type_hurricane_force_wind_watch: 'Vigilancia de vientos con fuerza de huracán',
  warning_type_special_marine_warning: 'Aviso marítimo especial',
  warning_type_marine_weather_statement: 'Comunicado meteorológico marítimo',
  warning_type_hazardous_seas_warning: 'Aviso de mar peligrosa',
  warning_type_brisk_wind_advisory: 'Aviso de brisa fresca',
  warning_type_low_water_advisory: 'Aviso de aguas bajas',
  warning_type_dense_fog_advisory: 'Aviso de niebla densa',
  warning_type_heavy_freezing_spray_warning: 'Aviso de rociones congelantes intensos',
  warning_type_strong_wind_warning: 'Aviso de viento fuerte',
  warning_type_gale_force_wind_warning: 'Aviso de temporal',
  warning_type_storm_force_wind_warning: 'Aviso de temporal fuerte',
  warning_type_wind_warning: 'Aviso de viento',
  warning_type_dense_fog_warning: 'Aviso de niebla densa',
  warning_type_icing_warning: 'Aviso de engelamiento',
  warning_type_typhoon_warning: 'Aviso de tifón',
  warning_type_wind_wave_warning: 'Aviso de oleaje',
  warning_type_wind_wave_advisory: 'Aviso preventivo de oleaje',
  warning_type_strong_wind_advisory: 'Aviso preventivo de viento fuerte',
  warning_type_storm_surge_warning: 'Aviso de marejada ciclónica',
  warning_type_storm_surge_advisory: 'Aviso preventivo de marejada ciclónica',
  warning_type_thunderstorm_warning: 'Aviso de tormentas eléctricas',
  warning_type_rough_sea_warning: 'Aviso de mar gruesa',
  warning_type_fog_warning: 'Aviso de niebla',
  sea_state_calm_rippled: 'Mar rizada',
  sea_state_smooth: 'Mar llana',
  sea_state_slight: 'Marejadilla',
  sea_state_moderate: 'Marejada',
  sea_state_rough: 'Mar gruesa',
  sea_state_very_rough: 'Mar muy gruesa',
  sea_state_high: 'Mar arbolada',
  sea_state_very_high: 'Mar montañosa',
  sea_state_phenomenal: 'Mar enorme',
  hazard_showers: 'Chubascos',
  hazard_reduced_visibility: 'Visibilidad reducida',
  hazard_haze: 'Calima',
  hazard_waterspout: 'Trombas marinas',
  hazard_freezing_spray: 'Rociones helados',
  hazard_ice: 'Hielo',
  marine_summary_sea_wind: '{{sea}}, viento del {{direction}} a {{speed}}.',
  marine_summary_wind_only_gusting: 'Viento del {{direction}} a {{speed}}, rachas de {{gust}}.',
  marine_summary_sea_wind_gusting:
    '{{sea}}, viento del {{direction}} a {{speed}}, rachas de {{gust}}.',
  marine_summary_wind_only: 'Viento del {{direction}} a {{speed}}.',
  marine_summary_sea_only: '{{sea}}.',
  marine_prediction_caveat_tide_one:
    'Las predicciones de marea son astronómicas, así que el tiempo de ese aviso puede subir o bajar el nivel real.',
  marine_prediction_caveat_tide_many:
    'Las predicciones de marea son astronómicas, así que el tiempo de esos avisos puede subir o bajar el nivel real.',
  marine_prediction_caveat_current_one:
    'Las predicciones de corriente son astronómicas, así que el tiempo de ese aviso puede reforzar o debilitar la corriente real.',
  marine_prediction_caveat_current_many:
    'Las predicciones de corriente son astronómicas, así que el tiempo de esos avisos puede reforzar o debilitar la corriente real.',
  marine_warning_active: 'Hay un aviso marítimo en vigor para esta zona.',
  marine_warnings_active: 'Hay avisos marítimos en vigor para esta zona.',
  marine_warning_upcoming: 'Un aviso marítimo entra en vigor en esta zona el {{time}}.',
  marine_warnings_upcoming:
    'Los avisos marítimos entran en vigor en esta zona a partir del {{time}}.',
  marine_summary_hazard_now: 'Ahora mismo: {{hazard}}.',
  marine_summary_hazard_later: 'En la previsión: {{hazard}}.',
  marine_tide_rising:
    'La marea está a {{height}} y subiendo: próxima pleamar {{next}} a las {{time}}.',
  marine_tide_falling:
    'La marea está a {{height}} y bajando: próxima bajamar {{next}} a las {{time}}.',
  marine_current_flood: 'Próxima corriente entrante {{speed}} a las {{time}}.',
  marine_current_ebb: 'Próxima corriente saliente {{speed}} a las {{time}}.',
  marine_current_slack: 'Próximo repunte a las {{time}}.',
  marine_current_now_flood: 'La corriente entra a {{speed}}.',
  marine_current_now_ebb: 'La corriente sale a {{speed}}.',
  marine_current_now_slack: 'La corriente está en repunte.',
  marine_current_peak: 'Máximo {{speed}} a las {{time}}.',

  // --- Chart furniture (navaid / hazard / POI click popups) ---
  // See en.js for the rules these follow. "IALA A" / "IALA B" stay untranslated
  // in every language: it is the standard's name.
  furn_light: 'Luz',
  furn_buoy: 'Boya',
  furn_beacon: 'Baliza',
  furn_wreck: 'Naufragio',
  furn_rock: 'Roca',
  furn_obstruction: 'Obstrucción',
  furn_anchorage: 'Fondeadero',
  furn_tss: 'Dispositivo de separación de tráfico',
  furn_routing: 'Organización del tráfico',
  furn_title_buoy: 'Boya {{category}}',
  furn_title_beacon: 'Baliza {{category}}',
  furn_cat_port: 'de babor',
  furn_cat_starboard: 'de estribor',
  furn_cat_preferred_channel_port: 'de canal preferido a babor',
  furn_cat_preferred_channel_starboard: 'de canal preferido a estribor',
  furn_cat_safe_water: 'de aguas seguras',
  furn_cat_isolated_danger: 'de peligro aislado',
  furn_cat_north: 'cardinal Norte',
  furn_cat_east: 'cardinal Este',
  furn_cat_south: 'cardinal Sur',
  furn_cat_west: 'cardinal Oeste',
  furn_cat_special: 'especial',
  furn_cat_mooring: 'de amarre',
  furn_cat_lateral: 'lateral',
  furn_characteristic: 'Característica',
  furn_range: 'Alcance',
  furn_height: 'Altura',
  furn_colour: 'Color',
  furn_shape: 'Forma',
  furn_lights_on_mark: 'Luces de esta marca',
  furn_topmark: 'Marca de tope',
  furn_class: 'Clase',
  furn_least_depth_over: 'Profundidad mínima sobre',
  furn_depth_over: 'Profundidad sobre',
  furn_state: 'Estado',
  furn_type: 'Tipo',
  furn_range_value: '{{value}} M',
  furn_metres_value: '{{value}} m',
  furn_cable: 'Cable submarino',
  furn_pipeline: 'Tubería submarina',
  furn_restricted_area: 'Zona restringida',
  furn_restriction: 'Restricción',
  furn_mpa: 'Área marina protegida',
  furn_protection: 'Protección',
  furn_agency: 'Gestionada por',
  furn_mpa_note: 'Una designación de conservación, no una restricción de navegación.',
  furn_sector: 'Sector',
  furn_sector_value: '{{from}}° → {{to}}°',
  lightw_f: 'Luz {{colour}} fija.',
  lightw_fl: 'Destella en {{colour}} cada {{period}} segundos.',
  lightw_fl_group: 'Destella en {{colour}} en grupos de {{count}}, cada {{period}} segundos.',
  lightw_lfl: 'Un destello largo {{colour}} cada {{period}} segundos.',
  lightw_q: 'Destellos {{colour}} rápidos.',
  lightw_iso: 'Luz {{colour}} y oscuridad iguales, cada {{period}} segundos.',
  lightw_oc: 'Luz {{colour}} fija con breve ocultación cada {{period}} segundos.',
  lightcolour_white: 'blanca',
  lightcolour_red: 'roja',
  lightcolour_green: 'verde',
  lightcolour_yellow: 'amarilla',
  furn_feet_charted_value: '{{feet}} ft ({{metres}} m en la carta)',
  furn_light_yes: 'sí',
  furn_shown_neutral: '{{colours}} (mostrado en neutro)',
  furn_note_light: 'Así se ve la luz de noche; los navegantes la identifican por ello.',
  furn_note_lateral_b_port:
    'Marca el lado IZQUIERDO del canal al regresar del mar (IALA B: cilíndrica verde).',
  furn_note_lateral_b_starboard:
    'Marca el lado DERECHO del canal al regresar del mar (IALA B: “rojo a la derecha al regresar”).',
  furn_note_lateral_a_port:
    'Marca el lado de BABOR del canal al entrar desde el mar (IALA A: rojo a babor).',
  furn_note_lateral_a_starboard:
    'Marca el lado de ESTRIBOR del canal al entrar desde el mar (IALA A: verde a estribor).',
  furn_note_safe_water:
    'Aguas seguras alrededor, normalmente la marca de recalada o de eje del canal.',
  furn_note_isolated_danger: 'Fondeada sobre un peligro aislado con agua navegable alrededor.',
  furn_note_cardinal_north: 'Marca cardinal: pase al NORTE de ella.',
  furn_note_cardinal_east: 'Marca cardinal: pase al ESTE de ella.',
  furn_note_cardinal_south: 'Marca cardinal: pase al SUR de ella.',
  furn_note_cardinal_west: 'Marca cardinal: pase al OESTE de ella.',
  furn_note_special: 'Marca especial (amarilla): límites, cables, amarres, regatas.',
  furn_note_preferred_starboard: 'Marca de bifurcación: el canal preferido queda a estribor.',
  furn_note_preferred_port: 'Marca de bifurcación: el canal preferido queda a babor.',
  furn_note_mooring: 'Boya de amarre.',
  furn_vessel: 'Buque',
  furn_depth_quality: 'Calidad de la sonda',
  furn_length: 'Eslora',
  furn_position_accuracy: 'Precisión de posición',
  furn_remarks: 'Observaciones',
  furn_circumstances: 'Circunstancias',
  furn_status: 'Estado',
  furn_note_shom: 'Cartografiado por el Shom (Francia). ©Shom, CC BY-SA 4.0.',
  furn_lock: 'Esclusa',
  furn_bridge: 'Puente',
  furn_overhead_cable: 'Cable aéreo',
  furn_notice_mark: 'Señal de aviso',
  furn_distance_mark: 'Marca de distancia',
  furn_daymark: 'Marca diurna',
  furn_channel: 'Canal',
  furn_vertical_clearance_closed: 'Galibo vertical (cerrado)',
  furn_vertical_clearance_open: 'Galibo vertical (abierto)',
  furn_datum: 'Referencia',
  furn_datum_value: '{plane} (VERDAT {code})',
  furn_datum_unknown: 'unknown code (VERDAT {code})',
  furn_note_ienc:
    'ENC fluvial (US Army Corps of Engineers). Los gálibos se miden sobre el plano de referencia indicado arriba; con el río crecido la altura libre real es menor.',
  furn_note_wreck:
    'Naufragio cartografiado. Las profundidades son valores de la carta, no verificados.',
  furn_note_anchorage: 'Zona de fondeo cartografiada.',
  furn_note_tss:
    'Vías de navegación de sentido único. Las embarcaciones pequeñas las cruzan perpendicularmente y se mantienen apartadas.',
  furn_route: 'Ruta',
  furn_fairway: 'Canal navegable',
  furn_recommended_track: 'Derrota recomendada',
  furn_navigation_line: 'Línea de navegación',
  furn_leading_line: 'Enfilación',
  furn_clearing_line: 'Línea de seguridad',
  furn_transit_line: 'Línea de tránsito',
  furn_traffic: 'Tráfico',
  furn_orientation: 'Orientación',
  furn_degrees_value: '{{value}}°',
  furn_note_fairway: 'Canal cartografiado: el paso mantenido o preferente.',
  furn_note_track: 'Línea de rumbo cartografiada.',
  furn_note_track_fixed_marks:
    'Línea de rumbo cartografiada, basada en marcas fijas (enfilaciones).',
  furn_note_leading_line:
    'Mantenga alineadas las marcas de enfilación para seguir la línea cartografiada.',
  furn_note_navigation_line: 'Línea de navegación cartografiada.',
  furn_poi_marina: 'Puerto deportivo',
  furn_poi_fuel: 'Combustible',
  furn_poi_slipway: 'Rampa de varada',
  furn_poi_ferry_terminal: 'Terminal de ferri',
  furn_poi_boatyard: 'Astillero',
  furn_poi_lighthouse: 'Faro',
  furn_note_slipway: 'Rampa de botadura.',
  // Layers sheet — UNTRANSLATED, English placeholders (2026-09-11). Catalog
  // parity is enforced by scripts/check-locale-keys.mjs, so a key cannot be
  // added to en.js alone; these are placeholders awaiting translation, not
  // a claim that the strings are localized.
  layers: 'Layers',
  layers_close: 'Close layers',
  layers_map_type: 'Map type',
  layers_visualizations: 'Visualizations',
  layers_standard_map: 'Standard Map',
  layers_depth_chart: 'Depth Chart',
  layers_moving_tides: 'Moving Tides',
  layers_moving_currents: 'Moving Currents',
  layers_wind_waves: 'Wind & Waves',
  layers_weather_radar: 'Weather Radar',
  layers_coming_soon: 'Coming soon',
  layers_no_currents_here: 'No current stations in view',
  layers_no_radar_here: 'No radar coverage in view',
  // The compass button's accessible name. {{point}} is a 16-point direction
  // (SSW) and {{deg}} the exact bearing — the face rounds to 8 points, this
  // does not. English placeholder in the non-English catalogs, awaiting
  // translation; catalog parity is enforced by scripts/check-locale-keys.mjs.
  follow_my_direction: 'Seguir mi orientación',
  compass_faces: 'Map faces {{point}} · {{deg}}°, tap for north-up',
  ww_row_no_data: '{{row}}: sin datos aquí',
  ww_row_no_forecast_after: '{{row}}: sin previsión después de {{when}}',
  ww_row_no_forecast: '{{row}}: sin previsión tan lejos',
  ww_unavailable: 'Datos del tiempo no disponibles',
  explore_show_player: 'Mostrar la línea de tiempo',
  explore_hide_player: 'Ocultar la línea de tiempo',

  // --- Route planning on /explore (2026-10-23) ---
  // Describe, never advise; never "safe". The service's own disclaimer is
  // printed verbatim from its response; route_disclaimer is only the fallback.
  // Mark nouns are all feminine (boya, luz, baliza) so colour and "la" agree.
  route_plan: 'Planificar una ruta',
  route_leave: 'Salir de la planificación de rutas',
  route_title: 'Ruta',
  route_prompt_start: 'Toca el agua en tu punto de salida.',
  route_prompt_start_desktop: 'Haz clic en el agua en tu punto de salida y luego en tu destino.',
  route_prompt_end: 'Salida fijada. Ahora toca tu destino.',
  route_prompt_end_desktop: 'Salida fijada. Ahora haz clic en tu destino.',
  route_drag_hint: 'Los marcadores se pueden arrastrar.',
  route_clear: 'Borrar',
  route_swap: 'Intercambiar salida y destino',
  route_share: 'Copiar enlace',
  route_copied: 'Enlace copiado',
  route_start: 'Salida',
  route_destination: 'Destino',
  route_near: 'cerca de {{name}}',
  route_loading: 'Trazando tu ruta…',
  route_loading_sub: 'Suele tardar un segundo o dos. Algunas zonas tardan hasta 30 segundos.',
  route_loading_slow: 'Seguimos calculando…',
  route_loading_slow_sub: 'Esta zona está tardando más de lo habitual.',
  route_summary_time: '{{duration}} a {{speed}}',
  route_planning_speed: 'Velocidad de planificación',
  route_shoalest: 'Menor profundidad en la ruta',
  route_planning_draft: 'calado de planificación',
  route_change: 'cambiar',
  route_draft_title: 'Calado de planificación',
  route_draft_help:
    'La profundidad para la que se planifica la ruta, no el calado de tu barco. Con más calado se encuentran menos pasos; con menos, más.',
  route_datum: 'Profundidades referidas al cero hidrográfico (MLLW), sin aplicar la marea.',
  route_unassured_note:
    'Los tramos naranjas cruzan aguas que la carta y los levantamientos no resuelven por debajo de {{draft}}.',
  route_row_start: 'Salida {{label}}',
  route_row_heading: 'rumbo {{course}}° ({{point}})',
  route_row_end: 'Llegada {{label}}',
  route_row_end_sub: 'fin de la ruta',
  route_turn_left: 'Gira a la izquierda al rumbo {{course}}°',
  route_turn_right: 'Gira a la derecha al rumbo {{course}}°',
  route_bear_left: 'Corrige a la izquierda al rumbo {{course}}°',
  route_bear_right: 'Corrige a la derecha al rumbo {{course}}°',
  route_then: '{{first}}, luego {{second}}',
  route_keep_mark: 'Deja la {{mark}} a tu {{hand}}',
  route_leave_channel: 'Sal del canal en la {{mark}}',
  route_on_your: 'a tu {{hand}} ({{side}})',
  route_hand_left: 'izquierda',
  route_hand_right: 'derecha',
  route_side_port: 'babor',
  route_side_starboard: 'estribor',
  route_mark_buoy: 'boya {{color}} {{num}}',
  route_mark_light: 'luz {{color}} {{num}}',
  route_mark_daybeacon: 'baliza {{color}} {{num}}',
  route_mark_lighted: '{{mark}} (luminosa)',
  route_red: 'roja',
  route_green: 'verde',
  route_follow: 'Sigue {{name}}',
  route_follow_two: 'Sigue {{first}}, luego {{second}}',
  route_follow_channel: 'el canal {{name}}',
  route_follow_named: 'el {{name}}',
  route_follow_unnamed: 'el canal balizado',
  route_follow_marks: '{{count}} marcas',
  route_greens_on: 'verdes a tu {{hand}}',
  route_reds_on: 'rojas a tu {{hand}}',
  route_show_marks: 'Mostrar marcas',
  route_hide_marks: 'Ocultar marcas',
  route_why: '¿Por qué gira aquí?',
  route_turn_reason: 'Gira aquí porque {{reason}}',
  route_lights: 'Luces al alcance: {{lights}}',
  route_stretch_unassured: 'profundidad no resuelta por debajo de {{draft}}',
  route_stretch_rocky: 'entre rocas cartografiadas',
  route_stretch_canal:
    'canal: funcionamiento de esclusas, compuertas y gálibo de puentes no modelados',
  route_step_of: 'Paso {{n}} de {{total}}',
  route_all_steps: 'Todos los pasos',
  route_prev_step: 'Paso anterior',
  route_next_step: 'Paso siguiente',
  route_minutes: '{{n}} min',
  route_hours: '{{h}} h',
  route_hours_minutes: '{{h}} h {{m}} min',
  route_err_on_land_origin: 'Tu punto de salida está en tierra según la carta',
  route_err_on_land_destination: 'Tu destino está en tierra según la carta',
  route_err_on_land_origin_sub:
    'Arrastra el marcador de salida al agua. Una marisma, una playa o un muelle cuentan como tierra en la carta.',
  route_err_on_land_destination_sub:
    'Arrastra el marcador de destino al agua. Una marisma, una playa o un muelle cuentan como tierra en la carta.',
  route_err_no_route: 'No hay ruta con un calado de planificación de {{draft}}',
  route_err_no_route_sub:
    'En algún punto entre los dos, la carta indica menos de {{draft}}. Con un calado de planificación menor puede haber un paso.',
  route_err_no_snap: 'No hay agua cartografiada cerca de uno de los puntos',
  route_err_no_snap_sub: 'Acerca los marcadores a aguas abiertas.',
  route_err_outside: 'Por ahora la planificación de rutas cubre aguas de EE. UU.',
  route_err_outside_sub:
    'Las rutas se construyen con cartas de la NOAA, así que ambos puntos deben estar en aguas de EE. UU. Más costas, más adelante.',
  route_err_timeout: 'El servicio de rutas ha tardado demasiado',
  route_err_timeout_sub: 'Algunas zonas tardan hasta 30 segundos y esta se ha quedado sin tiempo.',
  route_err_unavailable: 'La planificación de rutas no está disponible en este momento',
  route_err_unavailable_sub: 'Vuelve a intentarlo en un momento.',
  route_err_busy: 'Demasiadas solicitudes de ruta',
  route_err_busy_sub: 'Espera un minuto y vuelve a intentarlo.',
  route_try_again: 'Reintentar',
  route_disclaimer:
    'No apto para la navegación. Esta ruta sigue el canal balizado según la carta; no es una afirmación de aguas seguras.',
  route_promo_title: 'Sigue esta ruta en la app con el modo Go',
  route_promo_body:
    'El modo Go mantiene tu barco en la carta con la distancia a la próxima marca o al próximo giro, la profundidad bajo el casco y la marea y la corriente de la estación más cercana. En Tides Near Me para iPhone y Android, con suscripción.',
}
